import type { ZIncidentListItemIncident } from '@tsyl/zapan2/lib/types/ZIncidentListItem'

import getMeassurementData from '@/composables/getMeassurementData'
import type { MeasurementType } from '@/types/api/Masterdata'
import type { Incident } from '@/types/Incident'

export function transformIncidentApiToZIncident(incident: Incident, measurementsData?: MeasurementType[]): ZIncidentListItemIncident {
  const sizeMeassurement = getMeassurementData(incident, 'Size', measurementsData)
  const containmentMeassurement = getMeassurementData(incident, 'Containment', measurementsData)

  return {
    id: incident.id,
    name: incident.name,
    totalAcres: sizeMeassurement.value,
    percentContained: containmentMeassurement.value,
    discoveryTimestamp: incident.declared_timestamp,
    fireIdentifier: incident.id,
    AdminDivision: incident.county,
    firstLine: incident.county ? `${incident.name} - ${incident.county}` : `${incident.name}`,
    secondLine: `${sizeMeassurement.value || 0} ha · ${containmentMeassurement.value || 0}% ·`,
    extraValues: {
      color: incident.complexity?.color,
      latitude: incident.latitude,
      longitude: incident.longitude,
      hasPopulation: incident.hasPopulation,
      hasFobs: incident.hasFobs
    },
    icon: 'mdi-fire',
    sfdiColor: incident.sfdiLevelColor || '#808080'
  } as ZIncidentListItemIncident
}
